import Nav from 'components/Nav';
import Typography from 'components/Typography';
import Content from 'components/Content';
import Spacer from 'components/Spacer';

import SideBySide from 'components/SideBySide';
import Line from 'components/Line';
import OutlinedBox from 'components/OutlinedBox';
import Hero from 'components/Hero';
import ListItem from 'components/ListItem';
import Footer from 'components/Footer';

import { Summary } from 'components/pages/Attorneys';

import classes from 'styles/pages/Attorneys/Attorney.module.scss';
import NetworkIcon from 'icons/attnetwork.svg';

const joiningBenefits = [
  'Referrals to develop and grow your client base',
  'New business opportunities',
  'Faster payments for services',
];

const requirements = [
  'The managing attorney of the firm must have at least 8 years of experience practicing law.',
  'Have malpractice insurance of at least $100,000 per claim/$300,000 aggregate',
  'Have no bar or disciplinary complaints or malpractice history',
  'Be part of a fully staffed general practice law firm',
];

const goToPdf = () => {
  window.location = '/application-2020-pdf.pdf';
};

const navLinks = [
  { text: 'Our Customers', href: '#customers' },
  { text: 'Why MetLife', href: '#why' },
  { text: 'Requirements', href: '#requirements' },
  { text: 'About Us', href: '/about-us' },
];

const Attorney = () => (
  <>
    <Nav links={navLinks} />
    <main role="main" className={classes.main}>
      <Hero ctaButtonText="Join Our Network" ctaOnClick={goToPdf} imageUrl="/attorney-img.png">
        <h1>
          <Typography unsetColor variant="h1">
            Join Our Network and Grow Your Own
          </Typography>
        </h1>

        <Spacer v={16} />

        <Typography unsetColor>
          Grow your client base with referrals from some of the most well-known organizations in the
          U.S.
        </Typography>
      </Hero>

      <Spacer v={80} />

      <Content>
        <a name="customers" />
        <Summary />
      </Content>

      <Spacer v={80} />

      <Content>
        <a name="why" />
        <SideBySide>
          <img
            src="https://www.metlife.com/content/dam/metlifecom/us/evolution-content-hub/img/related-content-recirc/financial-wellness/2020_04_03_easy-tips-to-help-you-manage-uncertain-times_RelatedContent.jpg"
            alt=""
            className={classes.financialWellnessImage}
          />
          <div>
            <Typography variant="h1">What Does Joining Mean For You?</Typography>
            <Spacer v={8} />

            {joiningBenefits.map(benefit => (
              <>
                <ListItem key={benefit}>
                  <Typography>{benefit}</Typography>
                </ListItem>
                <Spacer v={8} />
              </>
            ))}
          </div>
        </SideBySide>
      </Content>

      <Line secondary />

      <Content>
        <Typography variant="h2" centered>
          <NetworkIcon className={classes.networkicon} />
          <Spacer inline h={8} />
          Attorney Network
        </Typography>

        <Spacer v={32} />

        <Typography>
          Our network is managed by attorneys who know the business. You’ll be given access to all
          the resources, assistance, and support we have, so you can do your job to the best of your
          abilities. Additionally, your firm will be given a panel representative to answer any
          questions you have about billing, coverage and more.
        </Typography>

        <Spacer v={80} />

        <OutlinedBox hideButton>
          <div className={classes.container}>
            <Typography variant="h1" className={classes.percentage}>
              99%
            </Typography>

            <Typography className={classes.ramble}>
              We choose the attorneys in our network based on location to ensure our clients’ have
              an attorney and our attorneys’ have a client. In fact, 99% of our attorneys work with
              members each year. This ensures that if you want work, you’ll have it.
            </Typography>
          </div>
        </OutlinedBox>

        <Spacer v={80} />

        <a name="requirements" />

        <SideBySide center>
          <div>
            <img src="/attorney-pen.png" alt="" style={{ maxWidth: '350px', flexShrink: 1 }} />
          </div>

          <div>
            <Typography variant="h1">What You Need To Join Our Network</Typography>

            <Spacer v={40} />

            {requirements.map(requirement => (
              <ListItem key={requirement}>
                <Typography>{requirement}</Typography>
              </ListItem>
            ))}
          </div>
        </SideBySide>

        <Spacer v={80} />

        <OutlinedBox buttonText="Join Our Network" onClick={goToPdf}>
          <Typography variant="h2">
            Grow your customer base as part of an attorney network of 18,000 strong.
          </Typography>
        </OutlinedBox>
      </Content>
    </main>

    <Footer />
  </>
);

export default Attorney;
